module.exports = __webpack_public_path__ + "img/bldc_hall.eaee77d1.png";